export class NavbarElement {
    constructor(
        protected path: String,
        protected route: String,
        protected title: String,
        protected authorization: String | Boolean = false,
        protected description: String = '') {

    }
}
export class NavbarParent extends NavbarElement {
    constructor(
        path: String,
        route: String,
        title: String,
        authorization: String | Boolean = false,
        description: String = '',
        protected children: NavbarElement[] = []) {
        super(path, route, title, authorization, description);
    }
}
export class Navbar {
    constructor(
        protected brand: NavbarElement,
        protected start: NavbarElement[] | NavbarParent[],
        protected end: NavbarElement[] | NavbarParent[]
    ) {

    }
}
const navbar = new Navbar(
    new NavbarElement('/', 'home', 'HOME', false, 'homepage'),
    [
        // Shop
        new NavbarElement('/daily-report', 'daily-report', 'DAILY_REPORT', 'shop.')
    ],
    [
        // Viewer
        new NavbarParent(null, null, 'VIEWER', 'viewer.', '', [
            new NavbarElement('/daily-report-review', 'daily-report-review', 'DAILY_REPORT_REVIEW', 'viewer.'),
            // new NavbarElement('/monthly-cash-desk', 'monthly-cash-desk', 'MONTHLY_CASH_DESK', 'viewer.'),
        ]),
        // Manager
        new NavbarParent(null, null, 'MANAGER', 'manager', '', [
            new NavbarElement('/assistants', 'assistants', 'ASSISTANTS', 'manager'),
            new NavbarElement('/offers', 'offers', 'OFFERS', 'manager'),
            new NavbarElement('/products', 'products', 'PRODUCTS', 'manager'),
            new NavbarElement('/services', 'services', 'SERVICES', 'manager'),
            new NavbarElement('/shops', 'shops', 'SHOPS', 'manager'),
            new NavbarElement('/monthly-cash-desk', 'monthly-cash-desk', 'MONTHLY_CASH_DESK', 'manager'),
            new NavbarElement('/daily-report-review', 'daily-report-review', 'DAILY_REPORT_REVIEW', 'manager'),
            new NavbarElement('/monthly-selling', 'monthly-selling', 'MONTHLY_SELLING', 'manager'),
            new NavbarElement('/totals', 'totals', 'TOTALS_REPORT', 'manager'),
        ]),

        // Admin
        new NavbarParent(null, null, 'ADMIN', 'admin', '', [
            new NavbarElement('/userManagement', 'userManagement', 'USER_MANAGEMENT', 'admin'),
            new NavbarElement('/signup', 'signup', 'SIGNUP', 'admin'),
            new NavbarElement('/configurations', 'configurations', 'CONFIGURATIONS', 'admin'),
        ]),

        // Generic
        new NavbarParent(null, null, 'USER', true, '', [

            new NavbarElement('/settings', 'settings', 'SETTINGS', true),
            new NavbarElement('/logout', 'logout', 'LOGOUT', true),
        ])
    ]
);

export default navbar;



// WEBPACK FOOTER //
// ./client/models/navbar.model.ts